import de from "./locales/de"
import deIconMap from "./locales/de-icons"
import en from "./locales/en"
import enIconMap from "./locales/en-icons"

let globalLocale = null;
let i18n = null;

const setLocale = (locale) => {
  // console.log("setLocale", locale)
  globalLocale = locale;
  i18n = globalLocale?.startsWith("en_") ? en : de;
};

const getIconMap = () => {
  return globalLocale?.startsWith("en_") ? enIconMap : deIconMap
}

const get = (obj, path) => path.trim().split(".").reduce((acc, part) => acc?.[part], obj)

const parseTemplate = (template, substitutes) => {
  return template.replace(/\{(\w+)\}/g, (match, variable) => {
    if (!substitutes) {
      console.error(`[form6-i18n] missing substitutes for template: ${template}`)
      return variable
    }
    console.log('template', template, ' ', substitutes)
    if (variable in substitutes) {
      return substitutes[variable];
    } else {
      return '';
    }
  });
}

const $t = (key, value = null) => {
  // console.log(i18n, key);
  const translationString = get(i18n, key)
  if (!translationString) {
    const msg = `i18n key not found ${key}`
    // console.error(msg)
    return msg
  }
  const substitutes = typeof value === 'object' ? value : {}
  const parsedTranslationString = parseTemplate(translationString, substitutes)
  const translations = parsedTranslationString.split(/ \| /g)
  const count = value !== null && Number.isInteger(value) ? value : 1
  if (count !== 1) {
    if (translations.length < 2) {
      const msg = `i18n key not found ${key} - for value {$value}`
      console.error(msg)
      return msg
    }
    return translations[1]
  }

  return translations[0]
};

const $tArray = (key) => {
  const v = get(i18n, key)
  if (!v) {
    console.error(`i18n key not found ${key}`)
    return []
  }

  if (Array.isArray(v)) {
    return v
  }

  throw new Error(`expected ${key} to be an array`)
}

export { getIconMap, setLocale, $t, $tArray };